import React, { useContext } from 'react';
import NoResultsFound from 'components/NoResultsFound/NoResultsFound';
import NoFiltersChangePosition from 'components/NoFiltersChangePosition/NoFiltersChangePosition';
import ChangePositionControlPanel from './components/ChangePositionControlPanel/ChangePositionControlPanel';
import ChangePositionList from './components/ChangePositionList/ChangePositionList';
import ModalWindows from './components/ModalWindows/ModalWindows';
import BtnBlock from './components/BtnBlock';
import AdditionalRestaurantsModal from './components/AdditionalRestaurantsModal/AdditionalRestaurantsModal';
import { AppContext, IAppContext } from 'appState/appContext';
import {
	ChangeCategoryPositionContext,
	IChangeCategoryPositionContext,
} from '../changeCategoryPositionState/changeCategoryPositionContext';
import style from './ChangeCategoryPosition.module.scss';

const ChangeCategoryPosition: React.FC = () => {
	const { positionsData, selectedRestaurant } =
		useContext<IChangeCategoryPositionContext>(ChangeCategoryPositionContext);
	const { isLoading } = useContext<IAppContext>(AppContext);

	return (
		<div className={style.container} data-test="ChangeCategoryPosition">
			<ChangePositionControlPanel />
			{positionsData?.length ? (
				<>
					<ChangePositionList />
					<BtnBlock />
					<ModalWindows />
					<AdditionalRestaurantsModal />
				</>
			) : (
				<NoResultsFound isVisible={!isLoading && !!selectedRestaurant} />
			)}
			<NoFiltersChangePosition isVisible={!selectedRestaurant} />
		</div>
	);
};

export default ChangeCategoryPosition;
